
import ItemNotFound from '@/components/common/ItemNotFound.vue'
import PageHeader from '@/components/common/PageHeader.vue'
import ProductList from '@/components/marumiyaProduct/ProductList.vue'
import DataTableMixin from '@/components/mixins/DataTableMixin.vue'
import { EXPORT_MARUMIYA_PRODUCTS, FETCH_MARUMIYA_PRODUCTS, SET_HAVE_NEW_EXPORT_RECORD } from '@/store/actions'
import { FILTER_DEBOUNCE_TIME, TABLE_SORT_TYPE } from '@/utils/constants'
import { EExportType } from '@/utils/enums'
import errorHandler from '@/utils/errorHandler'
import { IMarumiyaProduct } from '@/utils/types/model/marumiyaProduct'
import debounce from 'lodash/debounce'
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'

interface ICommonSearch {
  itemCode?: string
  sortBy?: string
  sortType?: string
  [key: string]: string | undefined
}

@Options({
  components: { PageHeader, ItemNotFound, ProductList },
  name: 'MarumiyaProducts',
})
export default class MarumiyaProducts extends Mixins(DataTableMixin) {
  dataSearch: ICommonSearch = {}
  debounceFilter!: () => void

  get isMarumiyaProductLoading(): boolean {
    return this.$store.getters.isMarumiyaProductLoading || false
  }

  get getMarumiyaProductTotalRecords(): number {
    return this.$store.getters.getMarumiyaProductTotalRecords || 0
  }

  get getMarumiyaProducts(): IMarumiyaProduct[] {
    return this.$store.getters.getMarumiyaProducts || []
  }

  refreshItemList() {
    this.debounceFilter()
  }

  currentPageChange(pageNum: number) {
    this.currentPageNum = pageNum
    this.redirectIndex()
    this.fetchList()
  }

  async exportCSV() {
    try {
      await this.$store.dispatch(EXPORT_MARUMIYA_PRODUCTS, {
        sortBy: this.dataSearch.sortBy,
        sortType: this.dataSearch.sortType,
      })
      this.$store.commit(SET_HAVE_NEW_EXPORT_RECORD, { exportType: EExportType.MASTER_DATA, isHaveNew: true })
    } catch (e) {
      errorHandler(e)
    }
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.dataSearch.sortBy = data.prop
    this.dataSearch.sortType = data.order ? this.handleGetSortType(data.order) : undefined
    this.currentPageNum = 1
    this.redirectIndex()
    this.fetchList()
  }

  handleGetSortType(order: string): string {
    if (order === 'ascending') {
      return 'asc'
    }
    return 'desc'
  }

  fetchList() {
    try {
      this.$store.dispatch(FETCH_MARUMIYA_PRODUCTS, {
        page: this.currentPageNum,
        limit: this.itemsPerPage,
        itemCode: this.dataSearch.itemCode || '',
        sortBy: this.dataSearch.sortBy,
        sortType: this.dataSearch.sortType,
      })
    } catch (e) {
      errorHandler(e)
    }
  }

  get isMarumiyaPackage() {
    return this.$store.getters.isMarumiyaPackage
  }

  created() {
    if (this.isMarumiyaPackage) {
      this.$router.push({ name: 'home' })
      return
    }
    this.routeName = 'marumiya-products'
    this.getQueryData()
    this.debounceFilter = debounce(() => {
      this.currentPageNum = 1
      this.redirectIndex()
      this.fetchList()
    }, FILTER_DEBOUNCE_TIME)
    this.fetchList()
  }
}
